import { createCenteredPopupWin } from '@/lib/helpers';
import { mainApi } from '@/lib/api';

export const setupNotionIntegration = () => {
    createCenteredPopupWin('https://api.notion.com/v1/oauth/authorize', 'Notion Integration', 500, 500);
};

export const getNotionEntity = async (type: 'page' | 'block') => {
    const response = await mainApi.get(`/v1/notion/entities?type=${type}`);
    return response.data;
};
